export const contentTableConfig = {
  title: '访问记录',
  propList: [
    {prop: 'consumerNickName', label: '客户昵称', minWidth: '80', slotName: 'consumer', align: 'left'},
    {prop: 'channelName', label: '直播间名', minWidth: '120'},
    {prop: 'deptName', label: '所属部门', minWidth: '80'},
    {prop: 'empName', label: '所属员工', minWidth: '80'},
    {prop: 'totalDuration', label: '访问总时长', minWidth: '120', slotName: 'duration', sortable: 'custom'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
